import React, { useMemo } from 'react';
import CalendarPeriodCells from './CalendarPeriodCells';
import { getMonthNames, isMonthOutOfRange, isSameMonth } from '../../../utils/calendar';

const MONTHS = Array.from({ length: 12 }, (_, month) => month);

const CalendarMonths = ({ viewDate, selected, minDate, maxDate, locale, onPick }) => {
  const names = useMemo(() => getMonthNames(locale, 'short'), [locale]);
  const year = viewDate.getFullYear();
  const today = new Date();

  return (
    <CalendarPeriodCells
      items={MONTHS}
      getLabel={(month) => names[month]}
      getTestId={(month) => `calendar-month-${month}`}
      isCurrent={(month) => isSameMonth(year, month, today)}
      isPicked={(month) => isSameMonth(year, month, selected)}
      isDisabled={(month) => isMonthOutOfRange(year, month, minDate, maxDate)}
      onPick={onPick}
    />
  );
};

export default CalendarMonths;
